/* global localStorage, Conf */
import React from 'react'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'

const Login = ({ store }) => {
  function handleLogin (e) {
    e.preventDefault()
    store.performLogin()
  }

  function handleLogout (e) {
    e.stopPropagation()
    store.logout()
  }

  const reloadVersion = store.newVersion
  const loginButtonStyle = {
    width: '46%',
    margin: '2%'
  }
  const pagePerPage = {
    _page: 1,
    _perPage: localStorage.getItem('cargo_perPage') || Conf.perPage || 50
  }
  const isIE = !window.navigator || !window.navigator.userAgent ||
    window.navigator.userAgent.indexOf('MSIE') > -1 ||
    window.navigator.userAgent.indexOf('Trident') > -1 ||
    window.navigator.userAgent.indexOf('Internet Explorer') > -1
  const isSafari = window.navigator && window.navigator.userAgent &&
    window.navigator.userAgent.toLowerCase().indexOf('safari') > -1 &&
    window.navigator.userAgent.toLowerCase().indexOf('chrome') < 0

  return (
    <section className='modal-dialog'>
      <div
        className='jumbotron'
        style={{
          boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }}>
        <h1>
          {Conf.siteName.toLowerCase() === 'filmcargo' && <img className='filmcargo-logo' src='/css/film-cargo.png' />}
          {Conf.siteName}
          {store.loggedUser && !reloadVersion &&
            <span className='logo-version'>{defaultConst.LATEST_VERSION[0]}<br />{defaultConst.LATEST_VERSION[1]}</span>}
        </h1>
        <p style={{ textAlign: 'justify' }}>
          {store.__('A film industry content management system and royalty engine, built for faster and easier management of feature films and series. This application is scalable from small businesses to large corporations.')}
        </p><br />
        <div className='panel panel-primary'>
          <div className='panel-heading'>
            <h3 className='panel-title'>{!store.loggedUser
              ? store.__('Start here:')
              : store.__('Continue here:')}</h3>
          </div>
          <div className='panel-body'>
            <p>
              {!store.loggedUser &&
                <button type='button' className='btn btn-default btn-lg' style={loginButtonStyle} onClick={handleLogin} disabled={isIE}>
                  <i className='glyphicon glyphicon-check' /> &nbsp;
                  {store.__('SIGN UP')}</button>}
              {!store.loggedUser &&
                <button type='button' className='btn btn-primary btn-lg' style={loginButtonStyle} onClick={handleLogin} disabled={isIE}>
                  <i className='glyphicon glyphicon-log-in' /> &nbsp;
                  {store.__('LOG IN')}</button>}
              {store.loggedUser &&
                <button type='button' className='btn btn-default btn-lg' style={loginButtonStyle} onClick={handleLogout}>
                  <i className='glyphicon glyphicon-log-out' /> &nbsp;
                  {store.__('LOGOUT')}</button>}
              {store.loggedUser && <button
                type='button'
                className='btn btn-primary btn-lg'
                style={loginButtonStyle}
                onClick={() => store.router.goTo(store.views.entity_list, {
                  entityname: 'films'
                }, store, { ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_FILMS] })}>{store.__('Open')} {Conf.siteName}</button>}
            </p>
            {!store.loggedUser && isIE &&
              <div className="alert alert-danger" style={{ textAlign: 'center', margin: '0 1.5em 1.5em 1.5em' }}>
                <strong>{
                  store.__('Your internet browser is not compatible with FilmCargo. Please use Google Chrome or another modern browser.')}
                </strong>
              </div>}
            {!store.loggedUser && isSafari &&
              <div className="alert alert-danger" style={{ textAlign: 'center', margin: '0 1.5em 1.5em 1.5em' }}>
                <strong>{store.__('Your internet browser is Safari.')}</strong><br />
                <strong>{store.__('If the Preferences.../Privacy/Prevent cross-site tracking is turned "on", the login will not work.')}</strong><br />
              </div>}
          </div>
        </div>
      </div>
    </section>
  )
}

export default inject('store')(observer(Login))
